<template>
    <div>
        <canvas ref="canvas" width="900" height="400"></canvas>
    </div>
</template>

<script>
import {Line, mixins} from 'vue-chartjs'
const {reactiveProp} = mixins

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ['chartData','options'],
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>